export default {
  default: [
    {
      name: "preScans",
      path: "/pre-scans",
      component: () => import("./views/PreScansView.vue")
    }
  ]
};
